import { css } from '@emotion/css';
import styled from '@emotion/styled';
import { Tabs } from 'antd';
import { PlatformIcon } from 'components/PlatformIcon';
import { useOrgConfigStateValue } from 'hooks/business/useOrgConfig';

interface PlatformTabsProps {
  platform?: Review.Platform;
  mercadoEnable: boolean;
  reviewStat: Review.Stat;
  onChange: (platform: string) => void;
}

export const PlatformTabs = (props: PlatformTabsProps) => {
  const {
    platform,
    mercadoEnable,
    reviewStat: { shopeeNum, lazadaNum, mercadoNum, tiktokNum, tiktokUsNum },
    onChange,
  } = props;

  const { whiteListConfig: { TIKTOK_REVIEW = false, TIKTOK_US_REVIEW = false } = {} } =
    useOrgConfigStateValue();

  const showTKUSTab = TIKTOK_REVIEW || TIKTOK_US_REVIEW;

  return (
    <TabContainer activeKey={platform} onTabClick={onChange}>
      <Tabs.TabPane
        tab={
          <div className="flex items-center gap-1">
            <PlatformIcon platform="shopee" />
            <div>Shopee({shopeeNum ?? 0})</div>
          </div>
        }
        key="SHOPEE"
      />
      <Tabs.TabPane
        tab={
          <div className="flex items-center gap-1">
            <PlatformIcon platform="lazada" />
            <div>Lazada({lazadaNum ?? 0})</div>
          </div>
        }
        key="LAZADA"
      />
      {mercadoEnable && (
        <Tabs.TabPane
          tab={
            <div className="flex items-center gap-1">
              <PlatformIcon platform="mercado" />
              <div>Mercado({mercadoNum ?? 0})</div>
            </div>
          }
          key="MERCADO"
        />
      )}
      {TIKTOK_REVIEW && (
        <Tabs.TabPane
          tab={
            <div className="flex items-center gap-1">
              <PlatformIcon platform="tiktok" />
              <div>TikTok({tiktokNum ?? 0})</div>
            </div>
          }
          key="TIKTOK"
        />
      )}
      {showTKUSTab && (
        <Tabs.TabPane
          className={tabItemCss}
          tab={
            <div className="flex items-center gap-1">
              <PlatformIcon platform="tiktok_us" />
              <div>TikTok US({tiktokUsNum ?? 0})</div>
            </div>
          }
          key="TIKTOK_US"
        />
      )}
    </TabContainer>
  );
};

const TabContainer = styled(Tabs)`
  .ant-tabs-ink-bar {
    display: none;
  }

  .ant-tabs-nav {
    margin: 0;
  }
  .ant-tabs-tab {
    margin-left: 0;
    padding-left: 16px;
    padding-right: 16px;
  }
`;

const tabItemCss = css``;
